(function($){
  
	$(document).ready(function(){
      $("a#kappa-sigma-official-store").on("click",function(e){
        e.preventDefault();
        $("#modal-kappa-sigma").modal();
      });
      	$( "ul.nested-menu-sidebar li a.sub_link" ).each(function() {
          var text = $(this).text();
          if (text.toLowerCase().indexOf("patriotic") >= 0){
            //$(this).addClass("patriotic_link");
          } else if (text.toLowerCase().indexOf("retriever") >= 0){
            $(this).addClass("retriever_link");
          } else if (text.toLowerCase().indexOf("graduation") >= 0){
            $(this).addClass("graduation_link");
          } else if (text.toLowerCase().indexOf("t shirts") >= 0){
            $(this).addClass("tshirt_link");
          } else if (text.toLowerCase().indexOf("clearance") >= 0){
            $(this).addClass("clearance_link");
          }
        });
      	$("ul.all-products-dropdown li.all-products-subcat ul li.all-products-subsubcat a").each(function() {
          var text = $(this).text();
          if (text.toLowerCase().indexOf("patriotic") >= 0){
            //$(this).addClass("patriotic_link");
          } else if (text.toLowerCase().indexOf("retriever") >= 0){
            $(this).addClass("retriever_link");
          } else if (text.toLowerCase().indexOf("graduation") >= 0){
            $(this).addClass("graduation_link");
          } else if (text.toLowerCase().indexOf("t shirts") >= 0){
            $(this).addClass("tshirt_link");
          } else if (text.toLowerCase().indexOf("clearance") >= 0){
            $(this).addClass("clearance_link");
          }
        });
      	$('#return-policy .title-wrapper').on("click",function(e){
          	$('#return-policy-dropdown').toggle();
          	$('#return-policy .title-wrapper i').toggle();
        });
      	$('#sub-box-details .title-wrapper').on("click",function(e){
          	$('#sub-box-details-dropdown').toggle();
          	$('#sub-box-details .title-wrapper i').toggle();
        });
		$('a#all-fraternity_button').on('click', function(e){
			e.preventDefault();
			$('.all-sorority-menu').hide();
			$('.all-fraternity-menu').show();
			if (!$(this).hasClass('selected')){
				$(this).addClass('selected');
			}
			if ($('a#all-sorority_button').hasClass('selected')){
				$('a#all-sorority_button').removeClass('selected');
			}
		});
		$('a#all-sorority_button').on('click', function(e){
			e.preventDefault();
			$('.all-fraternity-menu').hide();
			$('.all-sorority-menu').show();
			if (!$(this).hasClass('selected')){
				$(this).addClass('selected');
			}
			if ($('a#all-fraternity_button').hasClass('selected')){
				$('a#all-fraternity_button').removeClass('selected');
			}
		});
        $('a.bulk-order-form-button').on('click', function(e){
          e.preventDefault();
          $('#ProductBulkOrderForm').toggle();
          $([document.documentElement, document.body]).animate({
              scrollTop: $("#ProductBulkOrderForm").offset().top - 125
          }, 1500);
        });
      	$('header.site-header.minimal nav.nav-bar ul.site-nav > li.has-dropdown > a').on('click', function(e){
          e.preventDefault();
      	});
     	$('div.description .CategoryContentTop a.read-more').on('click', function(e){
          e.preventDefault();
          $([document.documentElement, document.body]).animate({
              scrollTop: $("#catbottom").offset().top - 125
          }, 2000);
      	});
	});
  
	var btn = $('#scroll-button');

	$(window).scroll(function() {
		if ($(window).scrollTop() > 300) {
			btn.addClass('show');
		} else {
			btn.removeClass('show');
		}
      if($(window).scrollTop() >= ($('#shopify-section-promos').outerHeight() + $('#shopify-section-header').outerHeight())) {
      	$('#shopify-section-header').addClass('scrolled');
      } else {
        $('#shopify-section-header').removeClass('scrolled');
      }
	});

	btn.on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({scrollTop:0}, '300');
	});


	// Script for bulk order Created By Judah 2019-06-12
	if($(".product-bulk-order").length){
		var bulkOrder = {}, 
			bulkProductData = $(".productjson").html(),
			bulkProduct = $.parseJSON(bulkProductData),
			bulkProductOptions = bulkProduct.options,
			bulkVariants = bulkProduct.variants;
      		console.log(bulkProductData);
		bulkOrder.each = function(ary, callback) {
			for (var i = 0; i < ary.length; i++) {
				callback(ary[i], i);
			}
		};
		bulkOrder.getVariant = function(selectedValues) {
			var found = null;
			if (selectedValues.length != bulkProductOptions.length) { return found; }

			bulkOrder.each(bulkVariants, function(variant) {
				var satisfied = true;
				for (var j = 0; j < selectedValues.length; j++) {
					var option_col = "option"+(j+1);
					if (variant[option_col] != selectedValues[j]) {
						satisfied = false;
					}
				}
				if (satisfied == true) {
					found = variant;
					return;
				}
			});
			return found;
		};

		bulkOrder.createOrder = function(){
			var bulkOrders =[];
			$(".order-row").each(function(){
				var $itemRow = $(this),
					bOrder = {},
					$optionSelectors = $itemRow.find('.option-selector'),
					$itemSelectors = $itemRow.find('.line-item-selector'),
					qty = parseInt($itemRow.find(".qty-selector").val()),
					itemProperties = {},					
					orderOptionValues = [];
				if($optionSelectors.length){
					$optionSelectors.each(function(){
						orderOptionValues.push($(this).val());
					})
				}else{
					orderOptionValues.push("Default Title");
				}
				if($itemSelectors.length){
					$itemSelectors.each(function(){
						var k = $(this).attr('data-item-property'),
							v  = $(this).val();
						if (v){
							itemProperties[k] = v;
						}						
					})
				}
				var targetVariantId = bulkOrder.getVariant(orderOptionValues).id;
				bOrder.quantity = qty; 
				bOrder.id = targetVariantId;
				if(Object.keys(itemProperties).length){
					bOrder.properties = itemProperties;
				};				
				bulkOrders.push(bOrder);		
			});
			return bulkOrders;
		};
		$(".bulk-order-submit").on('click', function(){
			var orderData = bulkOrder.createOrder();
			var completeOrder = function(){
				// If we still have requests in the queue, let's process the next one.
				if (orderData.length) {
					var request = orderData.shift();
					$.post('/cart/add.js', request, completeOrder);
				}
				// If the queue is empty, we will redirect to the cart page.
				else {
					document.location.href = '/cart';
				}
			}
			completeOrder();
		})
		// add remove order row
		$(document).on('click','.in-de-btn', function(e){
			if($(this).hasClass('increase')){
				$(".bulk-order-table-row.order-row:last").clone().appendTo(".bulk-order-table");
			} else if($(this).hasClass('decrease')){
				if($(".bulk-order-table-row.order-row").length >= 2){
					$(".bulk-order-table-row.order-row:last").remove();
				}				
			}
		})
	}
})(jQuery);